import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './SelectPriority.module.scss';
import classNames from 'classnames/bind';
import { FlagFillIcon } from '~/assets/icons';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { PRIORITIES } from '~/utils/constants/jobs';
import { SelectOption, SelectOptions } from '~/utils/types/common';
import { useEffect, useState } from 'react';

export type SelectPriorityProps = {
  name: string;
  options?: SelectOptions;
  value?: string;
  label?: string;
  onChange?: (...event: any[]) => void;
  error?: boolean;
  helperText?: string;
};

const cx = classNames.bind(styles);

const SelectPriority = (props: SelectPriorityProps) => {
  //#region Destructuring Props
  const { ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation('admin/component');
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const options: SelectOptions =
    props.options ||
    PRIORITIES.map((value) => {
      return {
        id: value,
        name: t(`selectPriority.priorities.${value}`),
      };
    });

  const label = props.label || t('selectPriority.label');
  const [value, setValue] = useState<string>('');
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const renderSelectOptionComponent = (item: SelectOption) => {
    return (
      <Box className={cx('priority', item.id)}>
        <FlagFillIcon className='w-[17px] option-icon' />
        {item.name}
      </Box>
    );
  };

  const renderSelectedOptionComponent = (item: SelectOption) => {
    return (
      <Box className={cx('priority', item.id, 'priority-selected')}>
        <FlagFillIcon className='w-[17px] option-icon' />
        {item.name}
      </Box>
    );
  };
  //#endregion Handle Function

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => {
          setValue(e.target.value);
          if (props.onChange) {
            props.onChange(e);
          }
        }}
        value={value}
        menuClassName={cx('select-priority-menu')}
        label={label}
        options={options}
        renderSelected={(item: SelectOption) => renderSelectedOptionComponent(item)}
        renderOptionItem={(item: SelectOption) => renderSelectOptionComponent(item)}
      />
    </>
  );
};

export default SelectPriority;
